<!-- app/javascript/dashboard/components-next/toast/ToastFix.vue -->

<!-- Serve para arrumar erro de aparecendo um toast notify vazio -->
<!-- REPONZA ------ ARRUMAR -->
<script setup>
import { watch, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useEmitter } from 'dashboard/composables/emitter';

// Este componente corrige problemas com toasts que aparecem em preto
// Removendo toasts pretos vazios automaticamente

const store = useStore();

// Função que limpa toasts vazios/pretos
const clearEmptyToasts = () => {
    // Verifica se há elementos de toast no DOM
    const toasts = document.querySelectorAll('.bg-slate-800.dark\\:bg-slate-700');

    // Filtra por toasts que estão vazios (causa do problema)
    toasts.forEach(toast => {
        const textElement = toast.querySelector('.text-white');
        if (!textElement || !textElement.textContent.trim()) {
            // Se estiver vazio, remover o elemento
            toast.remove();
        }
    });
};

// Ouvinte para evento de rotas
const clearToastsOnRouteChange = () => {
    // Aguardar um tempo para garantir que a navegação foi concluída
    setTimeout(() => {
        clearEmptyToasts();
    }, 300);
};

// Registra o ouvinte para o evento de navegação
useEmitter('route_change', clearToastsOnRouteChange);

// Também limpa quando o componente é montado
onMounted(() => {
    clearEmptyToasts();

    // Adiciona um observador para detectar novos toasts que apareçam
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                clearEmptyToasts();
            }
        });
    });

    // Começa a observar o corpo do documento para alterações
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Também faz uma limpeza a cada 2 segundos para garantir
    const interval = setInterval(clearEmptyToasts, 2000);

    // Limpa o intervalo quando o componente é desmontado
    onUnmounted(() => {
        clearInterval(interval);
        observer.disconnect();
    });
});
</script>

<template>
    <!-- Este componente não tem renderização visível, apenas funcionalidade -->
    <div style="display: none;"></div>
</template>
